// extracted by mini-css-extract-plugin
export var active = "_80-a";
export var activeIndicator = "_80-8";
export var animate = "_80-9";
export var disabled = "_80-b";
export var fullWidth = "_80-2";
export var lg = "_80-7";
export var md = "_80-6";
export var redoButtonTabGroup = "_80-0";
export var sm = "_80-5";
export var tabButton = "_80-3";
export var tabButtonsContainer = "_80-1";
export var xs = "_80-4";